import { getEnumValues } from './get-enum-values';
export enum CalendarEventParticipantResponse{
	Yes="Yes",
	No="No",
	Maybe="Maybe",
	None="None",
}
export const CalendarEventParticipantResponseValues = getEnumValues<CalendarEventParticipantResponse>(CalendarEventParticipantResponse)